const openExternalUrl = (link: string) => {
  try {
    window.open(link);
  } catch (error) {
    // log error
  }
};

export default openExternalUrl;
